import Icon from "@material-ui/icons/Notifications";
import NotificationList from "./NotificationList";
import NotificationCreate from "./NotificationCreate";
import NotificationShow from "./NotificationShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "notifications",
  list: NotificationList,
  create: NotificationCreate,
  show: NotificationShow,
  icon: Icon,
};
